export const PRODUCT_PATH = '/gift-cards/';
export const PRODUCT_EDIT_PATH = `/buy/product-edit/`;
export const BRANDCODE_PATH = `/gift-cards/brand/`;
export const HOME_PATH = '';

export const getBrandPath = brandCode => `${BRANDCODE_PATH}${brandCode}`;
export const getProductPath = product => `${PRODUCT_PATH}${product.slug}`;
export const getProductEditPath = lineItem => `${PRODUCT_EDIT_PATH}${lineItem.id}`;

export const homePath = HOME_PATH;
export const productPath = PRODUCT_PATH;
export const productEditPath = PRODUCT_EDIT_PATH;
export const summaryPath = '/buy/summary';
export const confirmationPath = '/buy/confirmation';
